import { createFileRoute } from "@tanstack/react-router";

import { legalFacts } from "@/features/legal/utils/legal-facts";
import { LegalDocumentPage } from "@/features/legal/components/legal-page";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/terms/")({
  // Out of search until `legalEntity` holds the real company details.
  staticData: { sitemap: false },
  head: () => ({ meta: pageMeta({ title: m.auth_legal_terms(), description: m.legal_terms_description() }) }),
  loader: () => ({ crumb: m.auth_terms_crumb() }),
  component: () => <LegalDocumentPage title={m.auth_legal_terms()} source={m.legal_terms_body(legalFacts())} />,
});
